export function CustomIdColumn({ columns }) {
  return columns["CUSTOM_ID"];
}
